<template>
  <div class="my-page">
    <!-- 头部渐变卡片:显示账号 + 余额 -->
    <div class="hero">
      <div class="hero-top">
        <img src="./../../assets/images/logo.png" class="avatar" />
        <div class="account-info">
          <div class="account-label">{{ $t('my.account') }}</div>
          <div class="account-value">{{ currentMobile }}</div>
        </div>
      </div>
      <div class="balance-block">
        <div class="balance-item main">
          <div class="k">{{ $t('my.balance') }}</div>
          <div class="v">₡{{ availableAmount$ }}</div>
        </div>
        <div class="balance-item" v-if="waitWithDrawAmount$ > 0">
          <div class="k">{{ $t('my.withdrawing') }}</div>
          <div class="v">₡{{ waitWithDrawAmount$ }}</div>
        </div>
      </div>
    </div>

    <!-- 功能菜单卡片 -->
    <div class="menu-card">
      <div class="menu-item" @click="rechargeHandler">
        <div class="icon-wrap recharge">
          <van-icon name="cash-back-record" class="ic" />
        </div>
        <div class="name">{{ $t('my.recharge') }}</div>
        <van-icon name="arrow" class="arrow" />
      </div>
      <div class="menu-item" @click="withdrawHandler">
        <div class="icon-wrap withdraw">
          <van-icon name="balance-o" class="ic" />
        </div>
        <div class="name">{{ $t('my.withdraw') }}</div>
        <van-icon name="arrow" class="arrow" />
      </div>
      <div class="menu-item" @click="modifyPasswordHandler">
        <div class="icon-wrap password">
          <van-icon name="lock" class="ic" />
        </div>
        <div class="name">{{ $t('my.changePassword') }}</div>
        <van-icon name="arrow" class="arrow" />
      </div>
      <div class="menu-item" @click="messageHandler">
        <div class="icon-wrap message">
          <van-icon name="chat-o" class="ic" />
        </div>
        <div class="name">{{ $t('my.messageCenter') }}</div>
        <van-icon name="arrow" class="arrow" />
      </div>
    </div>

    <van-button round block class="brand-btn-danger logout-btn" @click="logoutHandler">
      {{ $t('my.logout') }}
    </van-button>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { UserService } from '@/services';
import { storage } from '@/utils';
import { authMobile } from '@/constants';

const availableAmount$ = ref(0);
const waitWithDrawAmount$ = ref(0);
const currentMobile = ref();
const router = useRouter();
const getUserBalance = async () => {
  const { result } = await UserService.getUserBalanceApi();
  availableAmount$.value = result.availableAmount;
  waitWithDrawAmount$.value = result.waitWithDrawAmount;
};
const rechargeHandler = () => router.push('/recharge');
const withdrawHandler = () => router.push('/withdraw');
const modifyPasswordHandler = () => router.push('/changePassword');
const messageHandler = () => router.push('/message');
const logoutHandler = () => {
  storage.clear();
  router.push('/login');
};
onMounted(() => {
  getUserBalance();
  currentMobile.value = storage.getItem(authMobile);
});
</script>

<style lang="scss" scoped>
.my-page {
  min-height: 100vh;
  padding-bottom: 40px;
  background: var(--bg-page);
}

// 渐变头部
.hero {
  background: var(--brand-gradient);
  padding: 60px 40px 40px;
  color: #fff;
  position: relative;
  overflow: hidden;
}
.hero::before,
.hero::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}
.hero::before {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -80px;
}
.hero::after {
  width: 200px;
  height: 200px;
  bottom: -60px;
  left: -40px;
}

.hero-top {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
  .avatar {
    width: 130px;
    height: 130px;
    border-radius: 50%;
    border: 4px solid rgba(255, 255, 255, 0.4);
    background: #fff;
  }
  .account-info {
    flex: 1;
    .account-label {
      font-size: 24px;
      opacity: 0.85;
      margin-bottom: 8px;
    }
    .account-value {
      font-size: 34px;
      font-weight: 600;
      letter-spacing: 1px;
    }
  }
}

.balance-block {
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 1;
  .balance-item {
    flex: 1;
    background: rgba(255, 255, 255, 0.15);
    padding: 24px 28px;
    border-radius: 20px;
    backdrop-filter: blur(6px);
    .k {
      font-size: 22px;
      opacity: 0.85;
      margin-bottom: 8px;
    }
    .v {
      font-size: 40px;
      font-weight: 700;
      letter-spacing: 1px;
    }
    &.main {
      background: rgba(255, 255, 255, 0.22);
    }
  }
}

// 菜单卡片
.menu-card {
  margin: -30px 20px 20px;
  background: #fff;
  border-radius: 24px;
  padding: 8px 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 2;

  .menu-item {
    display: flex;
    align-items: center;
    padding: 28px 32px;
    border-bottom: 1px solid var(--border-soft);
    &:last-child {
      border-bottom: none;
    }
    &:active {
      background: #f9fafb;
    }
    .icon-wrap {
      width: 80px;
      height: 80px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 24px;
      .ic {
        font-size: 44px;
        color: #fff;
      }
      &.recharge {
        background: linear-gradient(135deg, #34d399, #10b981);
      }
      &.withdraw {
        background: linear-gradient(135deg, #fbbf24, #f59e0b);
      }
      &.password {
        background: linear-gradient(135deg, #667eea, #764ba2);
      }
      &.message {
        background: linear-gradient(135deg, #60a5fa, #3b82f6);
      }
    }
    .name {
      flex: 1;
      font-size: 32px;
      color: var(--text-primary);
      font-weight: 500;
    }
    .arrow {
      font-size: 38px;
      color: var(--text-muted);
    }
  }
}

.logout-btn {
  width: calc(100% - 40px) !important;
  margin: 40px 20px !important;
  height: 100px !important;
  font-size: 32px !important;
}
</style>
